export enum RoleEnum {
  Admin = 0,
  Lecturer = 1,
  Student = 2,
  Parent = 3,
}
